import { Outlet, useParams, Navigate } from "react-router-dom";
import { useSectionNavLinks } from "../_utils";
import AppLayout from "@/layouts/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

export default function RosterActivityLayout() {
  const { sectionId } = useParams();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const navLinks = useSectionNavLinks(sectionId);
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  if (!flagsLoaded) {
    return null;
  }

  if (flags["backoffice-section-roster-activity"] !== true) {
    return <Navigate to={sectionId ? `/sections/${sectionId}/change-requests` : "/sections"} replace />;
  }

  if (!sectionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Section ID not found" />
      </div>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && (
        <Breadcrumb
          compactOnly
          compactTitle="Roster Activity"
          backLink={{ to: "/sections/:sectionId", params: { sectionId } }}
        />
      )}
      <Outlet />
    </AppLayout>
  );
}
